import { Injectable } from "@angular/core";
import { url } from "inspector";

@Injectable()
export class CkEditorConfig {
    ckEditorConfig:any= {
        filebrowserUploadUrl:'https://ckeditor.com/apps/ckfinder/3.4.5/core/connector/php/connector.php?command=QuickUpload&type=Files',
        extraPlugins: 'sharedspace,uploadimage,uploadwidget,colorbutton,colordialog,tableselection,tabletools,tableresize,indent,indentblock',
        removePlugins: 'floatingspace,elementspath,magicline,wsc,scayt,liststyle',
        removeDialogTabs : 'image:advanced;link:advanced;image:Link;image:info',
        sharedSpaces: {
            top: 'ckEditBar'
        },

        toolbar: [{ name: 'basicstyles', groups: ['basicstyles'], items: ['Bold', 'Italic', 'Underline', 'Strike','Indent','Outdent'] },//, 'Subscript', 'Superscript'] },
        { name: 'paragraph', groups: ['list'], items: ['NumberedList', 'BulletedList'] },
        { name: 'insert', items: [ 'Image'] },
        { name: 'insert', items: [ 'Table'] },
        { name: 'insert', items: [ 'TextColor', 'BGColor' ] }
        //    , { name: 'insert', items: ['Image'] }
        ],
        removeButtons:'Subscript,Superscript',
        enterMode: 2,//2=means br tag
        shiftEnterMode: 2,//2=means br tag
        disallowedContent: 'div',
        startupFocus: false,
        readOnly: false,
        title: false,
        allowedContent: true,
        pasteFromWordPromptCleanup: false,
        pasteFromWordRemoveFontStyles: true,
        forcePasteAsPlainText: true,
        removeFormatAttributes:true,
        disableNativeSpellChecker:false,
     //   contentsCss : 'src/assets/css/ckeditorStyles.css',
        ignoreEmptyParagraph: true,
        colorButton_enableMore:true,
        clipboard_handleImages:false
       // disableNativeSpellChecker : false
        //commented for image insertion
        //imageUploadUrl: 'uploadImageAsNote.action',
        //uploadUrl: 'uploadImageAsNote.action'
    };
    momCkEditorConfig:any= {
        filebrowserUploadUrl:'https://ckeditor.com/apps/ckfinder/3.4.5/core/connector/php/connector.php?command=QuickUpload&type=Files',
       extraPlugins: 'sharedspace,uploadimage,uploadwidget,colorbutton,colordialog,tableselection,tabletools,tableresize,indent,indentblock',
        removePlugins: 'floatingspace,elementspath,magicline,wsc,scayt,liststyle',
        removeDialogTabs : 'image:advanced;link:advanced;image:Link;image:info',
        sharedSpaces: {
            top: 'ckEditBar'
        },
        toolbar: [{ name: 'basicstyles', groups: [ 'basicstyles' ], items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript','Indent','Outdent'] },
        { name: 'paragraph', groups: [ 'list'], items: [ 'NumberedList', 'BulletedList'] },
        { name: 'insert', items: [ 'Table'] },
        { name: 'insert', items: [ 'TextColor', 'BGColor'] }
         ],
         removeButtons:'Subscript,Superscript',
        enterMode: 2,//2=means br tag
        shiftEnterMode: 2,//2=means br tag
        disallowedContent: 'div',
        startupFocus: false,
        readOnly: false,
        title: false,
        allowedContent: true,
        pasteFromWordPromptCleanup: false,
        pasteFromWordRemoveFontStyles: true,
        forcePasteAsPlainText: true,
        removeFormatAttributes: true,
        disableNativeSpellChecker:false,
     //   contentsCss : 'src/assets/css/ckeditorStyles.css',
        ignoreEmptyParagraph: true,
        colorButton_enableMore:true 
        //disableNativeSpellChecker : false
        //commented for image insertion
        //imageUploadUrl: 'uploadImageAsNote.action',
        //uploadUrl: 'uploadImageAsNote.action'
    };
/*config.enterMode = 
    CKEDITOR.ENTER_P (1) � New <p> paragraphs are created.
    CKEDITOR.ENTER_BR (2) � Lines are broken with <br> elements.
    CKEDITOR.ENTER_DIV (3) � New <div> blocks are created.*/

}
